<template>
  <svg
    width="28"
    height="27"
    viewBox="0 0 28 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.9475 8.33625L12.7838 13.5L17.9475 18.6638L16.35 20.25L9.60001
      13.5L16.35 6.75L17.9475 8.33625Z"
      fill="#506784"
    />
  </svg>
</template>

<script>
export default {}
</script>
